import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  class: "ui-icon"
};
const _hoisted_2 = ["d"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.paths, (path, index) => {
    return _openBlock(), _createElementBlock("path", {
      key: index,
      d: path
    }, null, 8, _hoisted_2);
  }), 128))]);
}